import type { LifeService } from './sharedTypes';

export const lifeServices: LifeService[] = [
  {
    id: 'route',
    sectionName: '行程路線規劃',
    services: [
      {
        dataIndex: 'map',
        text: 'google map',
        icon: `${location.origin}${location.pathname}icon/lifeService/googleMap.svg`,
      },
    ],
  },
  {
    id: 'traffic',
    sectionName: '交通工具動線查詢',
    services: [
      {
        dataIndex: 'bus',
        text: '公車',
        icon: `${location.origin}${location.pathname}icon/lifeService/bus.svg`,
      },
      {
        dataIndex: 'train',
        text: '火車',
        icon: `${location.origin}${location.pathname}icon/lifeService/train.svg`,
      },
      {
        dataIndex: 'ubike',
        text: 'ubike',
        icon: `${location.origin}${location.pathname}icon/lifeService/ubike.svg`,
      },
      {
        dataIndex: 'MRT',
        text: '捷運',
        icon: `${location.origin}${location.pathname}icon/lifeService/MRT.svg`,
      },
    ],
  },
  {
    id: 'entertainment',
    sectionName: '周邊美食娛樂',
    services: [
      {
        dataIndex: 'tour',
        text: '觀光景點',
        icon: `${location.origin}${location.pathname}icon/lifeService/tour.svg`,
      },
      {
        dataIndex: 'restaurant',
        text: '餐廳',
        icon: `${location.origin}${location.pathname}icon/lifeService/restaurant.svg`,
      },
    ],
  },
  {
    id: 'cooking',
    sectionName: '料理資源',
    services: [
      {
        dataIndex: 'recipe',
        text: '電子食譜',
        icon: `${location.origin}${location.pathname}icon/lifeService/recipe.svg`,
      },
      {
        dataIndex: 'foodOrder',
        text: '食材訂購',
        icon: `${location.origin}${location.pathname}icon/lifeService/foodOrder.svg`,
      },
      {
        dataIndex: 'realTimeVegetablePrice',
        text: '即時菜價',
        icon: `${location.origin}${location.pathname}icon/lifeService/realTimeVegetablePrice.svg`,
      },
      {
        dataIndex: 'uberEats',
        text: 'Uber Eats',
        icon: `${location.origin}${location.pathname}icon/lifeService/uberEats.svg`,
      },
      {
        dataIndex: 'foodpanda',
        text: 'foodpanda',
        icon: `${location.origin}${location.pathname}icon/lifeService/foodpanda.svg`,
      },
    ],
  },
];

export const serviceLinks = {
  map: 'https://maps.google.com/?q=22.6204854,120.3170914',
  ubike: 'https://www.youbike.com.tw/region/main/stations/',
  tour: 'https://www.google.com/maps/search/%E8%A7%80%E5%85%89%E6%99%AF%E9%BB%9E/',
  restaurant: 'https://www.google.com/maps/search/%E9%A4%90%E5%BB%B3/',
  recipe: 'https://cookpad.com/tw',
  foodOrder: 'https://www.postmall.com.tw/mallProductList.aspx?kind=1&pkind=1',
  realTimeVegetablePrice:
    'https://m.moa.gov.tw/Transaction/AgriculturalProduct/Index',
  uberEats: 'https://www.ubereats.com/tw',
  foodpanda: 'https://www.foodpanda.com.tw/',
};

export const backgroundImageUrl = `${location.origin}${location.pathname}icon/lifeService/backgroundMap.svg`;
